$(document).ready(function() {
  /***********DANIM JACKET **********/
  $(".floating-button a").click(function(e){
    //e.preventDefault();
    $('html, body').animate({
      'scrollTop' : $(".PlusCustomForm").position().top
    });
  });

  AOS.init({
    easing: 'ease-in-out-sine'
  });
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  //     $('body').on('click', '.showClick.ShowMore', function() {
  //   $(this).html("Less");
  //     $(this).addClass("lessshow");
  //      $(this).removeClass("ShowMore");
  //     $(this).prev(".DetailPage").css("height","auto"); 
  //   });
  //   $('body').on('click', '.showClick.lessshow', function() {
  //   $(this).html("More.....");
  //     $(this).prev(".DetailPage").css("height","110px"); 
  //     $(this).removeClass("lessshow");
  //      $(this).addClass("ShowMore");

  //   });

  var OrderId = getCookie("OrderId");
  $(".hdrbg h3 b").html(OrderId);
  $(".RightWrap button.form-btn.btn.btn-default").click(function(){

    var nameGet = $(".NameForm").val();
    var emailGet = $(".EmailForm").val();
    var numberGet = $(".NumberForm").val();
    var selectGet = $(".SelectForm").val();
    var ImageGet = $(".ImageForm").attr("data-src");
    var ImageGet_2 = $(".ImageForm_2").attr("data-src");
    var ImageGet_3 = $(".ImageForm_3").attr("data-src");
    var ImageGet_4 = $(".ImageForm_4").attr("data-src");
    var ImageGet_5 = $(".ImageForm_5").attr("data-src");
    var DescriptionGet = $(".DescriptionForm").val();

    validateEmail(emailGet);

    function validateEmail(email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(email)) {
        $("input.form-control.EmailForm").css("border","1px solid red");
      }
      else if(emailGet==''){
        $("input.form-control.EmailForm").css("border","1px solid red");
      }
      else {

        $(".RightWrap button.form-btn.btn.btn-default").addClass("LoaderForm");
        var OrderId = Math.floor((Math.random() * 10000000) + 1);
        $("input.form-control.EmailForm").css("border","1px solid #cccccc");
        setCookie("OrderId", OrderId, 365);
        $.ajax({
          type: 'POST',
          url: 'https://techskipper.com/leathershopify/postmarkapp/src/plus-size-form.php',
          data: {ImageGet:(ImageGet),ImageGet_2:(ImageGet_2),ImageGet_3:(ImageGet_3),ImageGet_4:(ImageGet_4),ImageGet_5:(ImageGet_5),OrderId:(OrderId),name:(nameGet),email:(emailGet),phone_number:(numberGet),want_to_make:(selectGet),description:(DescriptionGet)},
          dataType: 'html',
          success: function(response){

            window.location.href = "/pages/thank-you" ;
            var OrderId = getCookie("OrderId");
            $(".hdrbg h3 b").html(OrderId);
          }
        })
      }
    }

  })

  /**************************** IMAGE UPLOAD ***************************************/
  $(".ImageForm").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.ImageForm').prop('files')[0];
      var imageName = $('.ImageForm').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.ImageForm').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://techskipper.com/leathershopify/postmarkapp/src/plus-size/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://techskipper.com/leathershopify/postmarkapp/src/plus-size/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#custom_form #bar").show();
              $("#custom_form #bar").text("("+percentComplete+"%)");
              $("#custom_form .bar_wrapper_1").show();
              $("#custom_form .imageWrapp").css("display","none");
              $("#custom_form .msg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("bar").style.width=percentComplete+'%';
              document.getElementById("bar").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#custom_form .imageWrapp").css("display","none");
                $("#custom_form .msg_uploading_1").html(imageName+" Image Uploaded");
                $("#custom_form .bar_wrapper_1.progress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#custom_form .ImageForm").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#custom_form").hide();
          $(".ImagesNames").html("<span>"+imageName+",</span>");
          $("#custom_form_2").show();
        }
      })
    }
  })

  /************** 2nd Image ********************************/
  $(".ImageForm_2").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.ImageForm_2').prop('files')[0];
      var imageName = $('.ImageForm_2').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.ImageForm_2').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://techskipper.com/leathershopify/postmarkapp/src/plus-size/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://techskipper.com/leathershopify/postmarkapp/src/plus-size/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#custom_form_2 #bar_2").show();
              $("#custom_form_2 #bar_2").text("("+percentComplete+"%)");
              $("#custom_form_2 .bar_wrapper_1").show();
              $("#custom_form_2 .imageWrapp").css("display","none");
              $("#custom_form_2 .msg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("bar_2").style.width=percentComplete+'%';
              document.getElementById("bar_2").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#custom_form_2 .imageWrapp").css("display","none");
                $("#custom_form_2 .msg_uploading_1").html(imageName+" Image Uploaded");
                $("#custom_form_2 .bar_wrapper_1.progress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#custom_form_2 .ImageForm_2").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#custom_form_2").hide();
          $("<span>"+imageName+",</span>").appendTo(".ImagesNames");
          $("#custom_form_3").show();
        }
      })
    }
  })

  /************** 3rd Image ********************************/
  $(".ImageForm_3").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.ImageForm_3').prop('files')[0];
      var imageName = $('.ImageForm_3').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.ImageForm_3').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://techskipper.com/leathershopify/postmarkapp/src/plus-size/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://techskipper.com/leathershopify/postmarkapp/src/plus-size/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#custom_form_3 #bar_3").show();
              $("#custom_form_3 #bar_3").text("("+percentComplete+"%)");
              $("#custom_form_3 .bar_wrapper_1").show();
              $("#custom_form_3 .imageWrapp").css("display","none");
              $("#custom_form_3 .msg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("bar_3").style.width=percentComplete+'%';
              document.getElementById("bar_3").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#custom_form_3 .imageWrapp").css("display","none");
                $("#custom_form_3 .msg_uploading_1").html(imageName+" Image Uploaded");
                $("#custom_form_3 .bar_wrapper_1.progress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#custom_form_3 .ImageForm_3").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#custom_form_3").hide();
          $("<span>"+imageName+",</span>").appendTo(".ImagesNames");
          $("#custom_form_4").show();
        }
      })
    }
  })

  /************** 4th Image ********************************/
  $(".ImageForm_4").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.ImageForm_4').prop('files')[0];
      var imageName = $('.ImageForm_4').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.ImageForm_4').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://techskipper.com/leathershopify/postmarkapp/src/plus-size/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://techskipper.com/leathershopify/postmarkapp/src/plus-size/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#custom_form_4 #bar_4").show();
              $("#custom_form_4 #bar_4").text("("+percentComplete+"%)");
              $("#custom_form_4 .bar_wrapper_1").show();
              $("#custom_form_4 .imageWrapp").css("display","none");
              $("#custom_form_4 .msg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("bar_4").style.width=percentComplete+'%';
              document.getElementById("bar_4").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#custom_form_4 .imageWrapp").css("display","none");
                $("#custom_form_4 .msg_uploading_1").html(imageName+" Image Uploaded");
                $("#custom_form_4 .bar_wrapper_1.progress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#custom_form_4 .ImageForm_4").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          console.log("RIGHT SUBMIT");
          $("#custom_form_4").hide();
          $("<span>"+imageName+",</span>").appendTo(".ImagesNames");
          $("#custom_form_5").show();
        }
      })
    }
  })

  /************** 5th Image ********************************/
  $(".ImageForm_5").change(function(){
    var image_size = (this.files[0].size);
    var ext = $(this).val().split('.').pop().toLowerCase();
    if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
      alert('Invalid extension!');
      $(this).val('');
    }
    else if(image_size > 15360000){
      alert('Please upload the Maximum of 15MB image.');
      $(this).val('');
    }	
    else{
      var file_data = $('.ImageForm_5').prop('files')[0];
      var imageName = $('.ImageForm_5').val().replace(/C:\\fakepath\\/i, '');
      var ne_get_1 = $('.ImageForm_5').val().replace(/C:\\fakepath\\/i, '');
      ne_get_1 = "https://techskipper.com/leathershopify/postmarkapp/src/plus-size/images/"+ne_get_1 ;
      var formData = new FormData($("#custom_form")[0]);
      formData.append('file', file_data);
      $.ajax({
        url:"https://techskipper.com/leathershopify/postmarkapp/src/plus-size/upload_image.php",
        type:"POST",
        data: formData,
        cache: false,
        dataType: "json",
        contentType:false,
        processData: false,
        xhr: function() {
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);
              $("#custom_form_5 #bar_5").show();
              $("#custom_form_5 #bar_5").text("("+percentComplete+"%)");
              $("#custom_form_5 .bar_wrapper_1").show();
              $("#custom_form_5 .imageWrapp").css("display","none");
              $("#custom_form_5 .msg_uploading_1").html("Uploading.... Please wait.");
              document.getElementById("bar_5").style.width=percentComplete+'%';
              document.getElementById("bar_5").innerHTML=percentComplete+'%';
              if (percentComplete === 100) {
                $("#custom_form_5 .imageWrapp").css("display","none");
                $("#custom_form_5 .msg_uploading_1").html(imageName+" Image Uploaded");
                $("#custom_form_5 .bar_wrapper_1.progress_bar").hide();
                //$("#custom_form_2").css("display","block");
                $("#custom_form_5 .ImageForm_5").attr("data-src",ne_get_1);
              }
            }
          }, false);
          return xhr;
        },
        success:function(response){
          $("<span>"+imageName+"</span>").appendTo(".ImagesNames");
          console.log("RIGHT SUBMIT");
          $("#custom_form_5").addClass("StopUpload");
        }
      })
    }
  })
});